function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//Private methods
var _fallbackCopyTextToClipboard = function _fallbackCopyTextToClipboard(text, cb) {
  var textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    cb();
  } catch (error) {
    throw Error(error);
  }
  document.body.removeChild(textArea);
};
var isIE = function isIE() {
  // eslint-disable-next-line
  return !!window.MSInputMethodContext && !!document.documentMode;
};

// Insert url param
var insertUrlParam = function insertUrlParam(key, value) {
  if (history.pushState) {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.pushState({
      path: newurl
    }, '', newurl);
  }
};

// Get All url params
var getAllUrlParams = function getAllUrlParams(search) {
  var hashes = search.slice(search.indexOf('?') + 1).split('&');
  var params = {};
  hashes.map(function (hash) {
    var _hash$split = hash.split('='),
      _hash$split2 = _slicedToArray(_hash$split, 2),
      key = _hash$split2[0],
      val = _hash$split2[1];
    params[key] = decodeURIComponent(val);
  });
  return params;
};

// Get param value
var getUrlParamValue = function getUrlParamValue(key) {
  var search = Object.entries(getAllUrlParams(window.location.search)).filter(function (param) {
    return param[0] === key;
  });
  return search[0] ? search[0][1] : null;
};

//Script exists in head of document. Taken from: https://github.com/kaimallea/isMobile
var isMobile = function isMobile() {
  if (window.isMobile) {
    return window.isMobile.phone;
  } else {
    return false;
  }
};
var copyToClipBoard = function copyToClipBoard(text, cb) {
  if (!navigator.clipboard) {
    _fallbackCopyTextToClipboard(text, cb);
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
    cb();
  }, function (error) {
    throw Error(error);
  });
};
var scrollIntoView = function scrollIntoView(elemToScrollTo, behaviour) {
  if (!isIE()) {
    elemToScrollTo.scrollIntoView({
      behavior: behaviour
    });
  }
};
export { insertUrlParam, getAllUrlParams, getUrlParamValue, isMobile, copyToClipBoard, scrollIntoView };